import { getItemFromStore, handleSkin } from "../helpers/utils";
// ** React Imports
import { useEffect, useState } from "react";

// ** Store Imports

export const useSkin = () => {
  // ** Get stored skin or fallback to system preference
  const [skin, setSkin] = useState(getItemFromStore("skin") || "dark");

  const handleSkinType = (type) => {
    handleSkin(type);
    setSkin(type); // Ensure state updates immediately
  };

  const isDark = skin === "dark";

  useEffect(() => {
    const syncSkinFromStore = () => {
      const currentSkin = getItemFromStore("skin") || "dark";
      setSkin(currentSkin);
    };

    window.addEventListener("storage", syncSkinFromStore);

    return () => {
      window.removeEventListener("storage", syncSkinFromStore);
    };
  }, []);

  useEffect(() => {
    const element = document.body;

    // Define class names for skins
    const classNames = {
      dark       : "dark-layout",
      bordered   : "bordered-layout",
      "semi-dark": "semi-dark-layout"
    };

    // Get the class to apply
    const newClass = classNames[skin];

    // Remove previous skin classes but keep other existing classes
    Object.values(classNames).forEach((cls) => element.classList.remove(cls));

    if (newClass) {
      element.classList.add(newClass);
    }
  }, [skin]);

  return { skin, setSkin: handleSkinType, isDark };
};
